import { APICore } from "./apiCore";

const api = new APICore();

// course
function addCourse(params: {
  name: string;
  categoryId: string;
  amount: string;
  offerAmount: string;
  description: string;
  description_ar: string;
  name_arabic: string;
  image: any;
  video: any;
  banner: any;
  enroll_text: string;
  enroll_text_ar: string;
  duration: any;
  enr_count: any;
  course_type: any;
  sortOrder: any;
}) {


  const baseUrl = "/course";
  return api.createWithFile(`${baseUrl}`, params);
}

function getCourse(filter: string, status: string) {
  const baseUrl = "/course";
  return api.get(`${baseUrl}/${filter}/${status}`, {});
}

function updateCourse(
  id: number,
  params: {
    name: string;
    categoryId: string;
    amount: string;
    offerAmount: string;
    description: string;
    description_ar: string;
    name_arabic: string;
    image: any;
    video: any;
    banner: any;
    enroll_text: string;
    enroll_text_ar: string;
    duration: any;
    enr_count: any;
    course_type: any;
    sortOrder: any;
  }
) {
  const baseUrl = `/course/${id}`;
  return api.updateWithFile(`${baseUrl}`, params);
}

function deleteCourse(id: number, checked: any) {
  const baseUrl = `/course/${id}/${checked}`;
  return api.delete(`${baseUrl}`);
}

function updateCourseEnrollmentApi(id: number, params: { checked: any }) {
  const baseUrl = `/course/${id}`;
  return api.updatePatch(`${baseUrl}`, params);
}

export { addCourse, deleteCourse, getCourse, updateCourse, updateCourseEnrollmentApi };
